module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_115_13.d9244817.pdf";